import React from 'react';

export default () => (
  <svg width="9" height="20" viewBox="-1 -1 7 19" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor">
      <path d="M3.75 4H1V1h3v3h-.25zm0 5.8H1v-3h3v3h-.25zm0 5.8H1v-3h3v3h-.25z" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/drag-handle-2.es6.js